"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "themeGet", {
  enumerable: true,
  get: function get() {
    return _themeGet.themeGet;
  }
});
Object.defineProperty(exports, "ThemeUIFlame", {
  enumerable: true,
  get: function get() {
    return _themeGet.flameTheme;
  }
});
Object.defineProperty(exports, "lightTheme", {
  enumerable: true,
  get: function get() {
    return _oldskool.theme;
  }
});
Object.defineProperty(exports, "flameTheme", {
  enumerable: true,
  get: function get() {
    return _flame.theme;
  }
});
exports.border = exports.FlameGlobalStyles = exports.FlameTheme = exports.FlameFonts = exports.themePicker = exports.Flex = exports.Box = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

var _emotionTheming = require("emotion-theming");

var _styledSystem = require("styled-system");

var _themeGet = require("./theme-get");

var _oldskool = require("./themes/oldskool");

var _flame = require("./themes/flame");

var _dark = require("./themes/dark");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const borderRadii = (0, _styledSystem.system)({
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  }
});
const border = (0, _styledSystem.compose)(borderRadii, _styledSystem.border);
exports.border = border;
const Box = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "e1rqh3k80",
  label: "Box"
})((0, _styledSystem.compose)(_styledSystem.space, _styledSystem.layout, _styledSystem.typography, _styledSystem.color, _styledSystem.flexbox));
exports.Box = Box;
const Flex = ( /*#__PURE__*/0, _styledBase.default)(Box, {
  target: "e1rqh3k81",
  label: "Flex"
})({
  name: "k008qs",
  styles: "display:flex;"
});
exports.Flex = Flex;

const themePicker = themeName => {
  switch (themeName) {
    case 'experimentaldark':
      return _dark.theme;

    case 'oldskool':
    case 'light':
      return _oldskool.theme;

    case 'flame':
    default:
      return _flame.theme;
  }
};

exports.themePicker = themePicker;

const FlameTheme = ({
  children,
  themeName,
  themeOverrides
}) => {
  const selectedTheme = themePicker(themeName);
  return (0, _core.jsx)(_emotionTheming.ThemeProvider, {
    theme: _objectSpread(_objectSpread({}, selectedTheme), themeOverrides)
  }, children);
}; // WARNING!
// This component will be deprecated in v3. Instead, use the link tag directly:
// https://github.com/lightspeed/flame#link-fonts


exports.FlameTheme = FlameTheme;

const FlameFonts = () => (0, _core.jsx)("link", {
  href: "https://fonts.googleapis.com/css?family=Lato:400,700&subset=latin-ext",
  rel: "stylesheet"
});

exports.FlameFonts = FlameFonts;

const FlameGlobalStyles = ({
  themeName
}) => {
  const selectedTheme = themePicker(themeName);
  return (0, _core.jsx)(_core.Global, {
    styles: /*#__PURE__*/(0, _core.css)("html{box-sizing:border-box;}*,*:before,*:after{box-sizing:inherit;}body{font-family:", (0, _themeGet.themeGet)('fontFamily.sans-serif', 'Lato, Helvetica Neue, Helvetica, Arial, sans-serif')({
      theme: selectedTheme
    }), ";padding:0;margin:0;background-color:", selectedTheme.colors.bodyBg, ";color:", selectedTheme.colors.textBody, ";};label:FlameGlobalStyles;")
  });
};

exports.FlameGlobalStyles = FlameGlobalStyles;